import type { WalletContextState } from '@solana/wallet-adapter-react';
import { usePreferences } from '../contexts/PreferencesContext';
import { TRPC } from '../contexts/TRPC';
import {
  uploadAppNftDataV2,
  uploadReleaseNftDataV2,
} from '../utils/arweaveUploadProviderBased';
import { releaseDebugLog } from '../utils/releaseDebugLogger';

type TRPCClient = TRPC['client'];

export function useArweaveUpload() {
  const { preferences } = usePreferences();

  const uploadAppNftData = async (
    wallet: WalletContextState,
    appData: Parameters<typeof uploadAppNftDataV2>[2],
    iconFile: File,
    trpc: TRPCClient,
    onProgress?: Parameters<typeof uploadAppNftDataV2>[5],
  ) => {
    releaseDebugLog(
      `Using canonical provider upload with provider: ${preferences.uploadProvider}`,
    );
    return uploadAppNftDataV2(
      wallet,
      preferences.uploadProvider,
      appData,
      iconFile,
      trpc,
      onProgress,
    );
  };

  const uploadReleaseNftData = async (
    wallet: WalletContextState,
    releaseData: Parameters<typeof uploadReleaseNftDataV2>[2],
    trpc: TRPCClient,
    onProgress?: Parameters<typeof uploadReleaseNftDataV2>[4],
  ) => {
    releaseDebugLog(
      `Using canonical provider upload with provider: ${preferences.uploadProvider}`,
    );
    return uploadReleaseNftDataV2(
      wallet,
      preferences.uploadProvider,
      releaseData,
      trpc,
      onProgress,
    );
  };

  return {
    uploadProvider: preferences.uploadProvider,
    uploadAppNftData,
    uploadReleaseNftData,
  };
}
